import {PosType} from "@/utils/grid-utils";
import {Sizes} from "@/constants/size";
import CU from "@/utils/c-u";
import {TeamTag} from "@/store/battle/types";
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {Point} from "@/model/point";

export class BattleUtils {

    public static getMultiPositions(canvas: HTMLCanvasElement, backKey: string) {
        switch (backKey) {
            case 'bbm_1':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 210 * CU.S,
                    [new Point(60, 381)],
                    [new Point(600-556, 370), new Point(600-481, 462)],
                    [new Point(49, 389), new Point(127, 474), new Point(219, 522)],
                    [new Point(600-556, 370), new Point(600-481, 462), new Point(600-388, 508), new Point(600-295, 538)],
                    [new Point(600-551, 391), new Point(600-458, 430), new Point(600-363, 462), new Point(600-267, 488), new Point(600-172, 502)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(600-60, 381)],
                    [new Point(546, 380), new Point(471, 472)],
                    [new Point(600-49, 389), new Point(600-127, 474), new Point(600-219, 522)],
                    [new Point(556, 370), new Point(481, 462), new Point(388, 508), new Point(295, 538)],
                    [new Point(551, 391), new Point(458, 430), new Point(363, 462), new Point(267, 488), new Point(172, 502)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_1b':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 210 * CU.S,
                    [new Point(120, 381)],
                    [new Point(600-526, 370), new Point(600-451, 462)],
                    [new Point(49, 389), new Point(127, 474), new Point(219, 522)],
                    [new Point(600-556, 370), new Point(600-481, 462), new Point(600-388, 508), new Point(600-295, 538)],
                    [new Point(600-551, 391), new Point(600-458, 430), new Point(600-363, 462), new Point(600-267, 488), new Point(600-172, 502)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(600-60, 381)],
                    [new Point(546, 380), new Point(471, 472)],
                    [new Point(600-69, 319), new Point(600-132, 444), new Point(600-229, 522)],
                    [new Point(556, 370), new Point(481, 462), new Point(388, 508), new Point(295, 538)],
                    [new Point(551, 391), new Point(458, 430), new Point(363, 462), new Point(267, 488), new Point(172, 502)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bb_6':
                return new MultiBattlePos(canvas.height / CU.S + 120, 1, PosType.CURVE_DOWN,
                    canvas.height - 280 * CU.S,
                    [new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(170, 485), new Point(300, 500), new Point(430, 485)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bb_7':
                return new MultiBattlePos(canvas.height / CU.S + 75, 1,
                    PosType.CURVE_DOWN, canvas.height - 300 * CU.S,
                    [new Point(300, 510)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(47, 475), new Point(139, 521), new Point(228, 556), new Point(324, 585), new Point(420, 605)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_3b':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 280 * CU.S,
                    [new Point(200, 450)],
                    [new Point(600-526, 370), new Point(600-451, 462)],
                    [new Point(49, 389), new Point(127, 474), new Point(219, 522)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(47, 475), new Point(139, 521), new Point(228, 556), new Point(324, 585), new Point(420, 605)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(513, 458)],
                    [new Point(546, 380), new Point(471, 472)],
                    [new Point(600-89, 399), new Point(600-172, 524), new Point(600-289, 602)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_4':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 210 * CU.S,
                    [new Point(300, 590)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(85, 397), new Point(156, 504), new Point(254, 557)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(424, 451)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_5':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 210 * CU.S,
                    [new Point(305, 480)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(500, 450)],
                    [new Point(100, 450), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_6':
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 210 * CU.S,
                    [new Point(305, 480)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(600-120, 350), new Point(600-40, 440), new Point(600-110, 560), new Point(600-200, 640)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(500, 450)],
                    [new Point(100, 450), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(120, 350), new Point(40, 440), new Point(110, 560), new Point(200, 640)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
            case 'bbm_3':
            default:
                return new MultiBattlePos(canvas.height / CU.S, 1,
                    PosType.CURVE_DOWN, canvas.height - 280 * CU.S,
                    [new Point(300, 590)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(47, 475), new Point(139, 521), new Point(228, 556), new Point(324, 585), new Point(420, 605)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(513, 458)],
                    [new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)],
                    [new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1), new Point(1, 1)]);
        }
    }

    public static getPositions(canvas: HTMLCanvasElement, backKey: string) {
        switch (backKey) {
            case 'bb_1':
                return new BattlePos(canvas.height / CU.S + 30, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 330 * CU.S, canvas.height - 530 * CU.S);
            case 'bb_2':
                return new BattlePos(-(800 - canvas.height / CU.S / 2), 0, PosType.LINE, PosType.LINE,
                    canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S + 230 * CU.S, canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S - 20);
            case 'bb_3':
            case 'bb_4':
            case 'bb_5':
                return new BattlePos(canvas.height / CU.S + 30, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 318 * CU.S, canvas.height - 497 * CU.S);
            case 'bb_6':
                return new BattlePos(canvas.height / CU.S + 120, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 280 * CU.S, canvas.height - 480 * CU.S);
            case 'bb_8':
                return new BattlePos(canvas.height / CU.S + 200, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 280 * CU.S, canvas.height - 480 * CU.S);
            case 'bb_9':
                return new BattlePos(canvas.height / CU.S + 90, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 318 * CU.S, canvas.height - 497 * CU.S);
            case 'bbm_1':
            case 'bbm_3':
                return new BattlePos(canvas.height / CU.S + 30, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 240 * CU.S, canvas.height - 440 * CU.S);
            case 'battle_back_winter':
                return new BattlePos(canvas.height / CU.S + 30, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 240 * CU.S, canvas.height - 500 * CU.S);
            case 'battle_back_cave':
                return new BattlePos(canvas.height / CU.S + 30, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 480 * CU.S);
            case 'battle_back_forrest':
                return new BattlePos(canvas.height / CU.S + 60, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 510 * CU.S);
            case 'battle_back_dark':
                return new BattlePos(canvas.height / CU.S + 60, 1, PosType.LINE, PosType.LINE,
                    canvas.height - 310 * CU.S, canvas.height - 545 * CU.S);
            case 'battle_back_sand':
                return new BattlePos(-(800 - canvas.height / CU.S / 2), 0, PosType.LINE, PosType.LINE,
                    canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S + 280 * CU.S, canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S + 30 * CU.S);
            case 'bb_cave':
                return new BattlePos(canvas.height / CU.S + 25, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 480 * CU.S);
            case 'bb_keeper':
                return new BattlePos(canvas.height / CU.S + 15, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 220 * CU.S, canvas.height - 390 * CU.S);
            case 'bb_11':
                return new BattlePos(canvas.height / CU.S + 100, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 240 * CU.S, canvas.height - 400 * CU.S);
            case 'bb_12':
                return new BattlePos(canvas.height / CU.S + 25, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 480 * CU.S);
            case 'bb_13':
                return new BattlePos(canvas.height / CU.S + 130, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 280 * CU.S, canvas.height - 455 * CU.S);
            case 'bb_14':
                return new BattlePos(canvas.height / CU.S + 120, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 250 * CU.S, canvas.height - 380 * CU.S);
            case 'bb_portal':
                return new BattlePos(canvas.height / CU.S + 80, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 225 * CU.S, canvas.height - 380 * CU.S);
            case 'bb_15':
                return new BattlePos(canvas.height / CU.S + 150, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 315 * CU.S, canvas.height - 500 * CU.S);
            case 'bb_fire':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 260 * CU.S, canvas.height - 430 * CU.S);
            case 'bb_air':
                return new BattlePos(canvas.height / CU.S + 20, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 260 * CU.S, canvas.height - 440 * CU.S);
            case 'bb_water':
                return new BattlePos(canvas.height / CU.S, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 240 * CU.S, canvas.height - 400 * CU.S);
            case 'bb_water_2':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 500 * CU.S);
            case 'bb_earth':
                return new BattlePos(canvas.height / CU.S + 150, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 270 * CU.S, canvas.height - 440 * CU.S);
            case 'bb_17':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 240 * CU.S, canvas.height - 440 * CU.S);
            case 'bb_18':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 230 * CU.S, canvas.height - 430 * CU.S);
            case 'battle_background_warrior_of_nothingness':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 480 * CU.S);
            case 'battle_background_symbol_earth':
                return new BattlePos(canvas.height / CU.S, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 280 * CU.S, canvas.height - 460 * CU.S);
            case 'battle_background_alt_mirograd':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 250 * CU.S, canvas.height - 450 * CU.S);
            case 'battle_background_forest_dream':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 230 * CU.S, canvas.height - 380 * CU.S);
            case 'battle_background_secret_road':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 220 * CU.S, canvas.height - 350 * CU.S);
            case 'battle_background_soul':
            case 'battle_background_lift_siege':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 270 * CU.S, canvas.height - 440 * CU.S);
            case 'battle_background_lift_siege_2':
                return new BattlePos(canvas.height / CU.S + 50 , 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 270 * CU.S, canvas.height - 450 * CU.S);
            case 'battle_background_final_boss':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 250 * CU.S, canvas.height - 380 * CU.S);
            case 'battle_background_warewolf_forest':
                return new BattlePos(canvas.height / CU.S , 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 450 * CU.S);
            case 'battle_background_spider_lair':
                return new BattlePos(canvas.height / CU.S + 50, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 300 * CU.S, canvas.height - 460 * CU.S);
            case 'battle_background_cave_harpy':
                return new BattlePos(canvas.height / CU.S + 25, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 220 * CU.S, canvas.height - 390 * CU.S);
            case 'bb_secret':
                return new BattlePos(canvas.height / CU.S, 1, PosType.CURVE_DOWN, PosType.CURVE_UP,
                    canvas.height - 275 * CU.S, canvas.height - 440 * CU.S);
            case 'battle_background':
        }
        return new BattlePos(-(800 - canvas.height / CU.S / 2), 0, PosType.LINE, PosType.LINE,
            canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S + 280 * CU.S, canvas.height / 2 - Sizes.CELL_HEIGHT / 2 * CU.S);
    }

    public static findTeam(cp: CreaturePanel) : TeamTag {
        return this.getTeam(cp.getCreature());
    }

    public static getTeam(c: Creature): TeamTag {
        let id = c.identifier;
        if (id != null) {
            if (id.startsWith("tm1_")) {
                return TeamTag.TM1;
            } else if (id.startsWith("tm2_")) {
                return TeamTag.TM2;
            } else if (id.startsWith("tm3_")) {
                return TeamTag.TM3;
            } else if (id.startsWith("tm4_")) {
                return TeamTag.TM4;
            }
        }
        return TeamTag.PLAYER;
    }
}

export interface IBattlePos {
    getBackY(): number;
    getBackOriginY(): number;
}

export class BattlePos implements IBattlePos {
    constructor(public backY: number, public backOriginY: number, public myPosType: PosType, public enemyPosType: PosType,
                public myY: number, public enemyY: number) {
    }

    getBackOriginY(): number {
        return this.backOriginY;
    }

    getBackY(): number {
        return this.backY;
    }
}

export class MultiBattlePos implements IBattlePos {
    constructor(public backY: number, public backOriginY: number, public myPosType: PosType, public myY: number,
                public t1P1: Point[], public t1P2: Point[], public t1P3: Point[], public t1P4: Point[], public t1P5: Point[], public t1P6: Point[],
                public t2P1: Point[], public t2P2: Point[], public t2P3: Point[], public t2P4: Point[], public t2P5: Point[], public t2P6: Point[]) {
    }

    getBackOriginY(): number {
        return this.backOriginY;
    }

    getBackY(): number {
        return this.backY;
    }
}
